<template>
  <div class="pageMenu">
    <ul>
      <li class="menuList" v-for="(item,index) in ArrURLs" :key="index" v-if="item.titUrl">
        <a :href="item.titUrl" class="colBlue">{{item.urlName}} <span class="separator">/</span> </a>
      </li>
      <li class="menuList" v-for="(item,index) in ArrURLs" :key="index" v-if="!item.titUrl">
        <span>{{item.urlName}} <span class="separator">/</span> </span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      titNames:'',
      titUrls:''
    },
    data () {
      return {
        nameArr : [],
        titUrlArr : [],

        ArrURLs:[],//导航标签
      }
    },
    mounted:function(){

       this.nameArr = this.titNames.split(",");
       this.titUrlArr = this.titUrls.split(",");

       let arrList=[]
       for(var i=0;i<this.nameArr.length;i++){
          let JsonArr={
              urlName:this.nameArr[i],
              titUrl:this.titUrlArr[i],
            }
            arrList.push(JsonArr)
       }
       this.ArrURLs=arrList

    //console.log('JsonArr ' + JSON.stringify(this.ArrURLs))


    //  $(".pageMenu").append('<a style="color:#2b86e3;font-size:13px" href="http://www.by56.com/CustomerCenter/MyInfo/Index.aspx">Dashboard</a><span class="aa" style="font-family:SimSun;color:#999;font-size:13px;"> </span>');

    //   for(var i=0;i<this.nameArr.length;i++){
    //     //判断链接为空的时候，不做跳转
    //     if (this.titUrlArr[i]) {
    //       $(".pageMenu").append('<span class="aa" style="font-family:SimSun;color:#999;font-size:13px;"> / </span><a style="font-size:13px;color:#2b86e3;text-decoration:none;" href='+this.titUrlArr[i]+'>'+this.nameArr[i]+'</a>');
    //     }else if(i==this.titUrlArr.length-1){
    //       $(".pageMenu").append('<span class="aa" style="font-family:SimSun;color:#999;font-size:13px;"> / </span><span style="font-size:13px;color:#333;text-decoration:none;">'+this.nameArr[i]+'</span>');
    //     }else{
    //       $(".pageMenu").append('<span class="aa" style="font-family:SimSun;color:#999;font-size:13px;"> </span><span style="font-size:13px;color:#999;text-decoration:none;">'+this.nameArr[i]+'</span>');
    //     }
    //   };


    },
    




    methods:{


    }

  }
</script>
<style lang="css" scoped>
.pageMenu{overflow:hidden;margin-bottom:-8px;}
.pageMenu ul li{float:left;}
.menuList .separator{margin:0 5px;color:#bbb;font-size:13px;}
.menuList:last-child .separator{display:none;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/menberPageMenu.vue